export default "__VITE_ASSET__BCZHpsk6__"